import { Pipe, PipeTransform } from '@angular/core';

import { COVERAGE_TYPE_LABELS } from 'src/shared/services/property-insurance.service';

@Pipe({
    name: 'coverageTypeLabel',
    standalone: false,
    pure: true
})
export class CoverageTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {return '';}
    return COVERAGE_TYPE_LABELS[value] || value;
  }
}
